import Typed from 'typed.js';

const dataAttributeName = 'data-ua-typed-options';

export default class UaTyped {
  constructor(element, options = {}) {
    this.element = typeof element === 'string' ? document.querySelector(element) : element;
    this.defaults = {};

    if (!this.element) return;

    this.dataSettings = this.element.hasAttribute(dataAttributeName)
      ? JSON.parse(this.element.getAttribute(dataAttributeName))
      : {};
    this.settings = Object.assign({}, this.defaults, this.dataSettings, options);
  }

  init() {
    if (!this.element || this.element.$typedInstance) return this;

    this.element.$typedInstance = new Typed(this.element, this.settings);
    return this;
  }
}

const initializeTyped = () => {
  document.querySelectorAll('.js-text-animation').forEach((element) => {
    new UaTyped(element).init();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeTyped, { once: true });
} else {
  initializeTyped();
}
